import { NB_CALL_PRICE_CAROUSEL } from '../../constants/experiments';
import { IAbUseExperiment } from '../../types/abUseExperiments';

export type TNewbuildingCallPriceCarouselExperimentGroup =
  /** Не показываем карусель **/
  | 'A'
  /** Показываем карусель **/
  | 'B'
  /** Показываем карусель с кпн **/
  | 'C';

export function getNewbuildingCallPriceCarouselExperimentGroup(
  experiments: IAbUseExperiment[],
): TNewbuildingCallPriceCarouselExperimentGroup {
  const experiment = experiments.find(e => e.experimentName === NB_CALL_PRICE_CAROUSEL);

  if (!experiment || !experiment.groupName) {
    return 'A';
  }

  return experiment.groupName as TNewbuildingCallPriceCarouselExperimentGroup;
}
